module.exports = require('./helpers/bundle-url').getBundleURL('8peBl') + "logo.c51670a8.svg";